import { createContext } from 'react';

import { stackingOrder } from './config';

export const StackingContext = createContext(stackingOrder.DEFAULT);
